import { DEFAULT_THROUGH_HOLE_VIA_UID } from "@buildwithflux/models";
import { keyBy } from "lodash";
import { filterTruthy } from "../helpers";
import { getSubSampledConfigsFromParentUid, getUserCreatedViaConfigs } from "./subSampling";
/**
 * Given an input array of via options (via config identifiers) and a map of via configurations,
 * return an enriched list of via options that includes:
 * - All available via configurations if no specific options are provided
 * - The specified via configurations and their sub-sampled configurations
 * - Always includes the default through-hole via configuration
 */
export function getEnrichedViaOptions(inputViaOptions, viaConfigs) {
    let viaOptions;
    if (inputViaOptions.length === 0 || inputViaOptions.includes("All")) {
        // If no via options are specified, use all available via configs
        viaOptions = Object.values(viaConfigs).map((config) => config.uid);
    }
    else {
        const viaConfigsByName = keyBy(getUserCreatedViaConfigs(viaConfigs), (config) => config.name);
        viaOptions = filterTruthy(inputViaOptions.map((viaConfigIdentifier) => viaConfigs[viaConfigIdentifier] ?? viaConfigsByName[viaConfigIdentifier])).flatMap((viaConfig) => [
            viaConfig.uid,
            // If the parent config is selected, add its sub-sampled configs as well
            ...getSubSampledConfigsFromParentUid(viaConfigs, viaConfig.uid).map((config) => config.uid),
        ]);
    }
    if (!viaOptions.includes(DEFAULT_THROUGH_HOLE_VIA_UID)) {
        viaOptions.push(DEFAULT_THROUGH_HOLE_VIA_UID);
    }
    return viaOptions;
}
//# sourceMappingURL=getEnrichedViaOptions.js.map